import { Navigate, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import * as Repository from "@/components/features/hotel-notification-settings/model/repository";

import { HotelNotificationSettingsPresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const HotelNotificationSettingsContainer = ({ hotelID }: Props) => {
	const { data } = Repository.Query.useHotelNotificationSettingsQuery(hotelID);

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <HotelNotificationSettingsPresenter data={data} />;
};

HotelNotificationSettingsContainer.displayName = "HotelNotificationSettingsContainer";
